import { FETCH_ERROR } from "@boark/shared/consts/fetch-error";
import { useQuery } from "@tanstack/react-query";

import { getIssue, getIssues } from "../services/issue";

export function useGetIssues() {
  return useQuery({
    queryKey: ["issues"],
    queryFn: () => getIssues(),
    staleTime: 1000 * 60,
    retry: (_failureCount, error: unknown) =>
      error !== FETCH_ERROR.UNAUTHORIZED,
  });
}

export function useGetIssue(id: string) {
  return useQuery({
    queryKey: ["issue", id],
    queryFn: () => getIssue(id),
    retry: (_failureCount, error: unknown) =>
      error !== FETCH_ERROR.UNAUTHORIZED,
  });
}
